module.exports = __webpack_public_path__ + "assets/on-reservation.b7fa181a.svg";